import { useRef } from 'react';
import { Button, CenterScreenModal } from '../atoms'
import { 
  useAddBudgetFormModalContext,
  useErrorHandlerContext,
  useIncidentDetailContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
} from '@/customHooks'
import { Col, Row } from 'react-grid-system';
import { CreateBudgetInput, useCreateBudgetFromIncidentMutation } from '@/graphql/generated';
import { AddBudgetFormControlled } from '../organism';

const textsData = {
  en: {
    title: 'Add a Budget',
    confirmation: {
      create: {
        title: 'Budget has been added',
        description: (subject: string) => `Budget ${subject} has been created succesfully`,
      },
      update: {
        title: 'Budget has been updated',
        description: (subject: string) => `Budget ${subject} has been updated succesfully`,
      }
    }
  },
  es: {
    title: 'Crear un Presupuesto',
    confirmation: {
      create: {
        title: 'Presupuesto creada con éxito',
        description: (subject: string) => `El Presupuesto ${subject} fue creada con éxito`,
      },
      update: {
        title: 'Presupuesto actualizada con exito',
        description: (subject: string) => `El Presupueto ${subject} fue actualizada con éxito`,
      }
    }
  }
}

export const AddBudgetFormModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const budgetDataRef = useRef<CreateBudgetInput | null>(null)
  
  const [createBudget, { loading: createLoading }] = useCreateBudgetFromIncidentMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { budgetData, isOpen, closeModal, } = useAddBudgetFormModalContext()

  const { incident, setIncident } = useIncidentDetailContext()
  
  const { open } = useErrorHandlerContext()

  const OnChangeHandle = (unityData: CreateBudgetInput) => {
    budgetDataRef.current = unityData
  }

  const onConfirmHandle = () => {
    if (!budgetDataRef.current) return
    
    if (budgetData === null) {
      createBudget({ variables: {
        incidentId: incident?.id ?? '',
        subject: budgetDataRef.current.subject,
        budgetCost: budgetDataRef.current.budgetCost,
        budgetEarning: budgetDataRef.current.budgetEarning ?? '',
        observation: budgetDataRef.current.observation,
        supplierId: budgetDataRef.current.supplierId,
        
      }})
      .then((response) => {
        setIncident(undefined)
        closeModal()
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: texts.confirmation.create.description(response.data?.createBudgetFromIncident.id ?? ''),
        })
      })
      .catch((error) => {
        closeModal()
        open(error)
      })
    } 
  }
  
  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <AddBudgetFormControlled
        defaultBudgetData={budgetData}
        onChange={OnChangeHandle}
      />
      <br />
      <Row justify="center" gutterWidth={32}>
        <Col xs="content">
          <Button secondary onClick={() => closeModal()} disabled={createLoading}>
            Volver
          </Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={() => onConfirmHandle()}
            isLoading={createLoading}
          >
            Aceptar
          </Button>
        </Col>
      </Row>
    </CenterScreenModal>
  )
}
